<template>
	<div class="submit-bg">
		<div class="submit">
			<div v-if="campaign.terms" class="submit__prompt">
				<p>{{ campaign.terms }}</p>
			</div>
			<div class="submit__form">
				<SubmitForm
					ref="form"
					:campaign="campaign"
					:loading="submitting"
					@submit="handleSubmit"
					@error="handleSubmitError"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/mixins/api'
import campaign from '@/mixins/campaign'
import toast from '@/mixins/toast'
import SubmitForm from '@/components/main/SubmitForm'

export default {
	name: 'Submit',
	data() {
		return {
			submitting: false
		}
	},
	methods: {
		async handleSubmit(body) {
			this.submitting = true
			try {
				// Create the submission
				await this.post('/submissions', { body })
				this.$router.push({ name: 'Submission successful' })
			} catch (err) {
				// Show relevant error
				if (err.name === 'APIValidationError') {
					this.toastWarn('Please check your submission and try again.')
				} else if (err.status === 413) {
					this.toastErr("The image you're trying to upload is too large.")
				} else if (err.status !== 500 && err.message) {
					this.toastErr(err.message)
				} else {
					this.toastErr('Failed to submit your idea. Please try again later.')
				}
			}
			this.submitting = false
		},
		handleSubmitError(err) {
			this.toastErr(err.message)
		}
	},
	mixins: [campaign, api, toast],
	components: {
		SubmitForm
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';
@import '~scss/mq';

.submit-bg {
	flex-grow: 1;
	background-color: $white;
}

.submit {
	@include corridor;
	position: relative;
	padding-top: 1.5rem;
	padding-bottom: 3rem;

	&__prompt {
		@include truncate-margin;
	}

	p {
		font-size: 1.125rem;
	}

	&__form {
		margin-top: 2rem;
		max-width: $canvas;
	}
}
</style>
